import { useTranslations } from 'next-intl'
import { useWatch } from 'react-hook-form'

import { TaxReceiptType as TaxReceiptTypeEnum } from '@/entities/user'
import { cn, useEnhancedFormContext, useScrollState } from '@/shared/lib'
import { Form } from '@/shared/ui'

import { TaxReceiptType } from './tax-receipt-type'
import { RECEIPT_INFORMATION_FIELDS } from '../model/form'

type Props = {
  scrollBlock?: ScrollLogicalPosition
}

export const ReceiptForm = ({ scrollBlock = 'end' }: Props) => {
  const t = useTranslations('receipt_information.issue_request')

  const { control, clearErrors, setValue } = useEnhancedFormContext()

  const { ref, scrollIntoView } = useScrollState<HTMLDivElement>()

  const receiptRequestedValue = useWatch({
    name: 'receiptRequested',
    control,
  })

  const receiptRequested = receiptRequestedValue === 'true'

  const handleReceiptRequestedChange = (value: string) => {
    clearErrors(RECEIPT_INFORMATION_FIELDS)

    if (value === 'true') {
      setValue('taxReceiptType', TaxReceiptTypeEnum.CASH_RECEIPT_PERSONAL)
    }

    setTimeout(() => {
      scrollIntoView({ block: scrollBlock, behavior: 'smooth' })
    }, 0)
  }

  return (
    <>
      <div className="space-y-2">
        <Form.Field name="receiptRequested">
          <Form.RadioGroup
            className="flex-row gap-6"
            onChange={handleReceiptRequestedChange}
          >
            <Form.Radio value="true">{t('option.request')}</Form.Radio>
            <Form.Radio value="false">{t('option.not_request')}</Form.Radio>
          </Form.RadioGroup>
          <Form.Message />
        </Form.Field>
      </div>

      <p
        className={cn(
          'typo-label2 font-normal whitespace-break-spaces text-gray-500',
          !receiptRequested && 'mb-0',
        )}
      >
        {t('description')}
      </p>

      {receiptRequested ? (
        <TaxReceiptType scrollBlock={scrollBlock} />
      ) : (
        <div ref={ref} />
      )}
    </>
  )
}
